import { PerformanceFacade } from '../facade/performance';
import { NOTIFICATION_RENDER_START_PERFORMANCE_MARK } from './constants';
import { Experiences } from './types';
var RENDER_NOTIFICATIONS_WITHOUT_CONTENT_TIMEOUT = 8000;
var RENDER_NOTIFICATIONS_WITH_CONTENT_TIMEOUT = 15000;
export var getExperienceTimeout = function getExperienceTimeout(experience) {
  if (experience === Experiences.RENDER_NOTIFICATIONS_WITH_CONTENT) {
    return RENDER_NOTIFICATIONS_WITH_CONTENT_TIMEOUT;
  }
  if (experience === Experiences.RENDER_NOTIFICATIONS_WITHOUT_CONTENT) {
    return RENDER_NOTIFICATIONS_WITHOUT_CONTENT_TIMEOUT;
  }
  return 10000;
};
export var getNotificationMountStartMark = function getNotificationMountStartMark() {
  var performance = new PerformanceFacade(window.performance);
  if (performance.isAvailable) {
    var _renderStartPerforman;
    var renderStartPerformanceMarks = performance.getEntriesByName(NOTIFICATION_RENDER_START_PERFORMANCE_MARK);
    return [performance, (_renderStartPerforman = renderStartPerformanceMarks[renderStartPerformanceMarks.length - 1]) === null || _renderStartPerforman === void 0 ? void 0 : _renderStartPerforman.startTime];
  }
  return [performance, undefined];
};